// src/utils/AxiosInterceptor.js
import axios from "axios";
import { auth } from "../firebase";
import apiBaseUrl from './apiBaseUrl';

const axiosInstance = axios.create({
  baseURL: apiBaseUrl,
});

axiosInstance.interceptors.request.use(async (config) => {
  await auth.authStateReady();
  if (config.signal?.aborted) throw new axios.CanceledError();
  if (['get', 'head'].includes(config.method) && !config.timeout) config.timeout = 15000;

  const user = auth.currentUser;
  if (user) {
    const token = await user.getIdToken();
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// No refresh logic needed — Firebase auto-refreshes ID tokens
export default axiosInstance;
